import { Status } from "./Status";

interface InvoiceCompletedStatusProps {
  completed: boolean;
}

export const InvoiceCompletedStatus = (props: InvoiceCompletedStatusProps) => {
  return <Status active={props.completed}>{props.completed ? "Completed" : "In Progress"}</Status>;
};
